export default __webpack_public_path__ + "static/media/shield.b5ccecc2.svg";